export const signUpIncentiveAssets = {
	background: "/spec_sign_up_incentive/bg.png",
	backgroundMobile: "/spec_sign_up_incentive/bg-mobile.png"
} as const;
